import { Loadable } from 'utils/components';
import { UPLOAD_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'Upload' */ './components/UploadPage')
  })
};
